export const GET_USER_OR_NAVIGATE_RETRY_COUNT = 5;
export const GET_USER_OR_NAVIGATE_RETRY_DELAY = 2000;
